import * as React from "react"
import { ShippingMethod } from "../../interfaces/SaleorTypes"
import styled from "styled-components"
import { getFormattedPrice } from "../../../utils/cart-helpers"
import BodyLarge from "../../atoms/typography/BodyLarge"

interface ShippingMethodCardProps {
  shippingMethod: ShippingMethod
  onShippingMethodClick: (method: ShippingMethod) => void
}

const RadioInput = styled.input`
  &[type="radio"] {
    background-color: transparent;
    border: .0625em solid #616161;
    border-radius: 50%;
    box-shadow: inset 0 0 0 0 white;
    cursor: pointer;
    font: inherit;
    height: 1em;
    outline: none;
    width: 1em;
    -moz-appearance: none;
    -webkit-appearance: none;
    &:checked {
      background-color: #616161;
      box-shadow: inset 0 0 0 .1875em #FFFFFF;
      -webkit-transition: background .15s, box-shadow .1s; 
      transition: background .15s, box-shadow .1s; 
    }
`

const RadioContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const TextContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 1em;
`

const ShippingMethodCard: React.FunctionComponent<ShippingMethodCardProps> = ({
  shippingMethod,
  onShippingMethodClick,
  ...props
}) => {
  return (
    <RadioContainer>
      <TextContainer>
        <RadioInput type="radio" name="radio-group" onClick={() => onShippingMethodClick(shippingMethod)} />
        <BodyLarge>{shippingMethod.name}</BodyLarge>
      </TextContainer>
      <BodyLarge>{getFormattedPrice(shippingMethod.price.amount, shippingMethod.price.currency)}</BodyLarge>
    </RadioContainer>
  )
}

export default ShippingMethodCard

//<Button title={shippingMethod.name + ' - ' + shippingMethod.price.amount + shippingMethod.price.currency} onClick={() => onShippingMethodClick(shippingMethod)}/>
